module.exports = __webpack_public_path__ + "ac69ff2ea416bfe79d3b3065ccc50077.png";